module.exports = __webpack_public_path__ + "img/suitcase.020b524b.png";